import { getDataLayerSnippet, getGTMScript, getIframeSnippet } from './snippets';
/**
 * Function to setup the Google Tag Manager
 * @param params - The snippets params
 */

var setupGTM = function setupGTM(params) {
  var getDataLayerScript = function getDataLayerScript() {
    var dataLayerScript = document.createElement('script');

    if (params.nonce) {
      dataLayerScript.setAttribute('nonce', params.nonce);
    }

    dataLayerScript.innerHTML = getDataLayerSnippet(params.dataLayer, params.dataLayerName);
    return dataLayerScript;
  };

  var getNoScript = function getNoScript() {
    var noScript = document.createElement('noscript');
    noScript.innerHTML = getIframeSnippet(params.id, params.environment, params.customDomain);
    return noScript;
  };

  var getScript = function getScript() {
    var script = document.createElement('script');

    if (params.nonce) {
      script.setAttribute('nonce', params.nonce);
    }

    script.innerHTML = getGTMScript(params.dataLayerName, params.id, params.environment, params.customDomain, params.customScriptName);
    return script;
  };

  return {
    getDataLayerScript: getDataLayerScript,
    getNoScript: getNoScript,
    getScript: getScript
  };
};
/**
 * Function to init the GTM
 * @param dataLayer - The dataLayer
 * @param dataLayerName - The dataLayer name
 * @param environment - Specify the custom environment to use
 * @param nonce - Server-generated nonce
 * @param id - The ID of the GTM
 */


export var initGTM = function initGTM(_ref) {
  var dataLayer = _ref.dataLayer,
      dataLayerName = _ref.dataLayerName,
      environment = _ref.environment,
      nonce = _ref.nonce,
      id = _ref.id,
      customDomain = _ref.customDomain,
      customScriptName = _ref.customScriptName;
  var gtm = setupGTM({
    dataLayer: dataLayer,
    dataLayerName: dataLayerName,
    environment: environment,
    nonce: nonce,
    id: id,
    customDomain: customDomain,
    customScriptName: customScriptName
  });
  var dataLayerScript = gtm.getDataLayerScript();
  var script = gtm.getScript();
  var noScript = gtm.getNoScript();
  document.head.insertBefore(dataLayerScript, document.head.childNodes[0]);
  document.head.insertBefore(script, document.head.childNodes[1]);
  document.body.insertBefore(noScript, document.body.childNodes[0]);
};
/**
 * Function to send the events to the GTM
 * @param dataLayerName - The dataLayer name
 * @param data - The data to push
 */

export var sendToGTM = function sendToGTM(_ref2) {
  var _ref2$dataLayerName = _ref2.dataLayerName,
      dataLayerName = _ref2$dataLayerName === void 0 ? "dataLayer" : _ref2$dataLayerName,
      data = _ref2.data;

  if (window[dataLayerName]) {
    window[dataLayerName].push(data);
  } else {
    console.warn("dataLayer ".concat(dataLayerName, " does not exist, has script be initialized"));
  }
};